
type Props = {
    test: boolean
}

const If: React.FC<Props | any> = (props) => {
    if(props.test) {
        return props.children
    } else {
        return false
    }
}

export default If;